import { render, staticRenderFns } from "./ChangesHistoryItem.vue?vue&type=template&id=90d80aaa&scoped=true"
import script from "./ChangesHistoryItem.vue?vue&type=script&lang=js"
export * from "./ChangesHistoryItem.vue?vue&type=script&lang=js"
import style0 from "./ChangesHistoryItem.vue?vue&type=style&index=0&id=90d80aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d80aaa",
  null
  
)

export default component.exports